import { Location } from "../../../../../../../common/models";

interface LocationTreeSelectValueTemplateProps {
    location?: Location;
}

const LocationTreeSelectValueTemplate = (
    props: LocationTreeSelectValueTemplateProps
) => {
    const { location } = props;

    return <span className="text-default">{location?.name}</span>;
};

export default LocationTreeSelectValueTemplate;
